import axios from './providers/axios';
import {convertBooleanValuesToNumbers} from "@/utils/utils";

const gameLabService = {
    getGameLabs(page, filters = []) {
        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');

            return axios.get(`/v1/admin/gamelabs/store?limit=20&page=${page}${tempFilters}`);
        } else {
            return axios.get(`/v1/admin/gamelabs/store?limit=20&page=${page}`);
        }
    },
    getCompanyGameLabs(page, company, filters = [], searchText = '', limit = 20, type = 'gameLabs') {
        let queryParams = `limit=${limit}&page=${page}&companyId=${company}&type=${type}`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/company/getAssigned?${queryParams}`);
    },

    getGroups(page) {
        return axios.get(`/v1/admin/gamelabs/group/store?page=${page}&limit=20`);
    },
    getGroupList() {
        return axios.get(`/v1/admin/gamelabs/group/store?list=1`);
    },
    addGroup(data) {
        return axios.post(`/v1/admin/gamelabs/group/add`, data);
    },
    updateGroup(data) {
        return axios.put(`/v1/admin/gamelabs/group/update`, data);
    },
    deleteGroup(id) {
        return axios.delete(`/v1/admin/gamelabs/group/delete/${id}`);
    },
    getGameLabDetails(id, lang = 'tr') {
        return axios.get(`/v1/admin/gamelabs/getFromId/${id}`, {
            headers: {
                "Accept-Language": lang,
            }
        });
    },
    addGameLab(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post(`/v1/admin/gamelabs/add`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },
    updateGameLab(data, lang = 'tr') {
        data = convertBooleanValuesToNumbers(data);

        return axios.post(`/v1/admin/gamelabs/update`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Accept-Language": lang,
            }
        });
    },
    assignGameLabs(data) {
        return axios.post('/v1/admin/gamelabs/assign', data);
    },
    deleteGameLabAssign(data) {
        return axios.post('/v1/admin/gamelabs/assign/delete', data);
    },
    getCopy(gameLabId) {
        return axios.post('/v1/admin/gamelabs/copy', {
            gameLabsId: gameLabId
        });
    },
    deleteGamelabs(id) {
        return axios.delete(`/v1/admin/gamelabs/delete/${id}`);
    },

    getLogs(lang, page = 1, limit = 20){
        return axios.get(`/v1/admin/gamelabs/getLogs?page=${page}&limit=${limit}`, {
            headers:{
                "Accept-Language": lang,
            }
        });
    },

    getDetailLogs(lang, id, page = 1, limit = 20){
        return axios.get(`/v1/admin/gamelabs/getLogById/${id}?page=${page}&limit=${limit}`, {
            headers:{
                "Accept-Language": lang,
            }
        });
    },

    getUserGameLabs(page, userId, filters = [], searchText = '', limit = 20) {
        let queryParams = `limit=${limit}&page=${page}&userId=${userId}&type=gameLabs`;

        if (searchText) {
            queryParams += `&searchText=${encodeURIComponent(searchText)}`;
        }

        if (filters && filters.length > 0) {
            const tempFilters = filters.map((filter) => {
                return `&${filter.key}=${filter.value}`;
            }).join('');
            queryParams += tempFilters;
        }

        return axios.get(`/v1/admin/user/getAssigned?${queryParams}`);
    },

    getAssignedGameLabs(userId, type = 'gameLabs') {
        return axios.get('/v1/admin/user/getAssigned', {
            params: {
                userId,
                type
            }
        });
    }
}

export default gameLabService;
